/**
 * Converts a value to an array if it isn't already one.
 *
 * @param value - The value to convert to an array. Can be of any type.
 * @param options - Options to customize the behavior of the function.
 * @param options.ignoreInvalid - Whether to return an empty array for null, undefined, or NaN values.
 * @returns An array containing the input value. If the input is already an array, returns it unchanged.
 *
 * @example
 * ```ts
 * ensureArray(5); // Returns: [5]
 * ensureArray([1, 2, 3]); // Returns: [1, 2, 3]
 * ensureArray('hello'); // Returns: ['hello']
 * ```
 */
export const ensureArray = <T>(value: T | T[], options: { ignoreInvalid: boolean } = { ignoreInvalid: false }): T[] => {
  const { ignoreInvalid } = options;
  if (ignoreInvalid && (value == null || Number.isNaN(value))) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
};
